module.exports = __webpack_public_path__ + "static/media/PSIRF_book_green.d58d35bb.png";